import React from 'react';
import { render } from 'react-dom';
import { MenuList, IMenuList } from '@sky-it-livedata/livedata-sports-design-system';

const MENU_LIST = '.ftbl__menu-list';
const MENU_LIST_TITLE = '.ftbl__menu-list__title';
const MENU_LIST_TEXT = '.ftbl__menu-list__button__p';
const MENU_LIST_ITEM = '.ftbl__menu-item';

export function hydrateDropdowns({ tagsToExclude }: { tagsToExclude: string[] }) {
  const menuListElements = selectMenuListElements(tagsToExclude);
  menuListElements.forEach(renderMenuList);
}

function renderMenuList(menuList: HTMLElement) {
  try {
    const title = menuList.querySelector(MENU_LIST_TITLE)?.textContent?.trim() || '';
    const text = menuList.querySelector(MENU_LIST_TEXT)?.textContent?.trim() || '';
    const links = Array.from(menuList.querySelectorAll<HTMLAnchorElement>(MENU_LIST_ITEM)).map((item) => {
      const label = item.textContent?.trim() || '';
      const href = item.href || '';
      return { label, href };
    });
    const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      window.location.href = e.currentTarget.value;
    };
    const props: IMenuList = {
      variant: 'DROPDOWN',
      showSelected: false,
      menuSize: 'dynamic',
      title,
      text,
      links,
      onClick,
    };

    const menuListHeight = menuList.clientHeight;

    const wrapper = document.createElement('div');
    menuList.parentNode?.replaceChild(wrapper, menuList);
    wrapper.style.height = `${menuListHeight}px`;

    render(<MenuList {...props} />, wrapper);
  } catch (error) {
    console.error('Error hydrating dropdown:', error);
  }
}

function selectMenuListElements(tagsToExclude: string[]): HTMLElement[] {
  const allMenuListElements = document.querySelectorAll<HTMLElement>(MENU_LIST);
  const filteredElements = Array.from(allMenuListElements).filter((element) => {
    return !tagsToExclude.some((tag) => {
      const parentElement = element.closest(tag);
      return parentElement !== null;
    });
  });

  return filteredElements;
}
